module.exports = __webpack_public_path__ + "img/whatsapp.ebaed03b.svg";